/**
 * Formats a date string into a standardized long format: "Wed, 8 Feb 2026"  [Day, D Mon YYYY]
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string or empty string if invalid
 */
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    
    // Check if date is actually valid
    if (isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }).format(date);
};


/**
 * Formats a date specifically for <input type="date" /> (YYYY-MM-DD)
 * @param {string|Date} dateString 
 * @returns {string}
 */
export const formatForInput = (dateString) => {
    // if (!dateString) return '';
    // return new Date(dateString).toISOString().split('T')[0];
    // Don't use the above, because it returns a date as UTC

    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    // Months are 0-indexed in JS, so +1. padStart ensures '05' instead of '5'
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;    
};


/**
 * Formats a date string into a detailed timestamp: "Wed, 8 Feb 2026 @ 10:21"
 * @param {string|Date} dateString - The date/timestamp to format
 * @returns {string} Formatted string or empty string if invalid
 */
export const formatHumanReadableTimestamp = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    
    // Check if date is actually valid
    if (isNaN(date.getTime())) return '';

    // Create the date part: "Wed, 8 Feb 2026"
    const datePart = new Intl.DateTimeFormat('en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }).format(date);

    // Create the time part: "10:21"
    const timePart = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // Set to true if you prefer AM/PM
    }).format(date);

    return `${datePart} @ ${timePart}`;
};